module.exports = "/_next/static/images/Hero-8f6afccf2348d5b3ec12bfa5b5bba508.webp";